<template>
  <!-- 编辑界面 -->
  <el-dialog
    :title="title"
    :visible.sync="formVisible"
    width="50%"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-form
      label-width="160px"
      :model="form"
      ref="formRef"
      :rules="type == 'view' ? {} : formRules"
      :disabled="type == 'view'"
    >
      <el-form-item label="考试名称：" prop="name">
        <el-input
          maxlength="30"
          size="small"
          v-model="form.name"
          auto-complete="off"
          placeholder="请输入名称"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="考试日期：" prop="testDate">
        <el-date-picker
          v-model="form.testDate"
          type="date"
          placeholder="选择考试日期"
          value-format="yyyy-MM-dd"
          @input="testDateChange"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="理论试卷：" prop="questionPaperId">
        <el-select
          size="small"
          v-model="form.questionPaperId"
          placeholder="请选择试卷"
        >
          <el-option
            v-for="item in PaperName"
            :label="item.name"
            :value="item.questionPaperId"
            :key="item.questionPaperId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="理论考试日期："
        prop="theoryTime"
        v-if="form.testDate"
      >
        <el-time-picker
          v-model="form.startTime"
          placeholder="开始时间"
          @change="validateField('theoryTime')"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
        <el-time-picker
          v-model="form.endTime"
          placeholder="结束时间"
          @change="validateField('theoryTime')"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item label="实操试卷：" prop="questionPracticalPaperId">
        <el-select
          size="small"
          v-model="form.questionPracticalPaperId"
          placeholder="请选择试卷"
        >
          <el-option
            v-for="item in handsOnOption"
            :label="item.name"
            :value="item.questionPaperId"
            :key="item.questionPaperId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="实操考试日期："
        prop="practicalTime"
        v-if="form.testDate"
      >
        <el-time-picker
          v-model="form.practicalExamStartTime"
          placeholder="开始时间"
          @change="validateField('practicalTime')"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
        <el-time-picker
          v-model="form.practicalExamEndTime"
          placeholder="结束时间"
          @change="validateField('practicalTime')"
          value-format="HH:mm:ss"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item label="开考机制：" prop="loginEndTime">
        开考
        <el-input-number
          size="small"
          v-model="form.loginEndTime"
          :min="1"
          :max="1000"
          :precision="0"
        ></el-input-number
        >分钟后，不可参加考试
      </el-form-item>
      <el-form-item label="提前交卷：" prop="advanceSubmissionTime">
        考试结束前
        <el-input-number
          size="small"
          v-model="form.advanceSubmissionTime"
          :min="1"
          :max="1000"
          :precision="0"
        ></el-input-number
        >分钟，可以提前交卷
      </el-form-item>

      <el-form-item v-if="type !== 'view'">
        <el-button plain @click="closeDialog">关闭</el-button>
        <el-button type="primary" plain @click="submitForm('formRef')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { allQuestionPaperInfo } from "../../api/system";
import { AddExamination, UpdateExamination } from "../../api/addAndUpadte";
import { formatDate } from "@/utils/formatDate";
import { createInfo, editInfo, practicalPaperList } from "@/api/exam";
export default {
  data() {
    const isSameDay = (start, end) => {
      return (
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate()
      );
    };
    const checkTestDate = (rule, value, callback) => {
      if (!this.form.testDate) {
        return callback(new Error("请选择考试日期"));
      }
      // 选中的日期（yyyy-MM-dd）
      const selected = new Date(this.form.testDate);
      selected.setHours(0, 0, 0, 0);

      // 今天（归零）
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selected < today) {
        return callback(new Error("考试日期不能早于当前日期"));
      }

      callback();
    };
    const checkTheoryTime = (rule, value, callback) => {
      if (!this.form.startTime)
        return callback(new Error("请选择理论考试开始时间"));
      if (!this.form.endTime)
        return callback(new Error("请选择理论考试结束时间"));

      const theory = [this.form.startTime, this.form.endTime];
      const practical = [
        this.form.practicalExamStartTime,
        this.form.practicalExamEndTime
      ];
      const theoryStart = new Date(this.form.testDate + " " + theory[0]);
      const theoryEnd = new Date(this.form.testDate + " " + theory[1]);
      const practicalStart = new Date(this.form.testDate + " " + practical[0]);
      const practicalEnd = new Date(this.form.testDate + " " + practical[1]);
      if (theoryStart <= new Date()) {
        callback(new Error("理论考试开始时间不能小于当前时间"));
      }
      if (theoryStart >= theoryEnd) {
        return callback(new Error("理论考试开始时间必须小于结束时间"));
      }
      if (practicalStart <= new Date()) {
        callback(new Error("实操考试开始时间不能小于当前时间"));
      }
      if (practicalStart >= practicalEnd) {
        return callback(new Error("实操考试开始时间必须小于结束时间"));
      }

      // ✅ 与实操时间不能冲突
      if (
        practical &&
        practical.length === 2 &&
        this.isTimeRangeOverlap(theory, practical)
      ) {
        return callback(new Error("理论考试时间与实操考试时间冲突"));
      }

      callback();
    };
    const checkPracticalTime = (rule, value, callback) => {
      if (!this.form.practicalExamStartTime)
        return callback(new Error("请选择实操考试开始时间"));
      if (!this.form.practicalExamEndTime)
        return callback(new Error("请选择实操考试结束时间"));
      const theory = [this.form.startTime, this.form.endTime];
      const practical = [
        this.form.practicalExamStartTime,
        this.form.practicalExamEndTime
      ];
      const theoryStart = new Date(this.form.testDate + " " + theory[0]);
      const theoryEnd = new Date(this.form.testDate + " " + theory[1]);
      const practicalStart = new Date(this.form.testDate + " " + practical[0]);
      const practicalEnd = new Date(this.form.testDate + " " + practical[1]);
      if (theoryStart <= new Date()) {
        callback(new Error("理论考试开始时间不能小于当前时间"));
      }
      if (theoryStart >= theoryEnd) {
        return callback(new Error("理论考试开始时间必须小于结束时间"));
      }
      if (practicalStart <= new Date()) {
        callback(new Error("实操考试开始时间不能小于当前时间"));
      }
      if (practicalStart >= practicalEnd) {
        return callback(new Error("实操考试开始时间必须小于结束时间"));
      }

      // ✅ 与实操时间不能冲突
      if (
        practical &&
        practical.length === 2 &&
        this.isTimeRangeOverlap(theory, practical)
      ) {
        return callback(new Error("理论考试时间与实操考试时间冲突"));
      }

      callback();
    };
    return {
      formRules: {
        name: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: ["blur", "change"]
          },
          {
            message: "请勿输入特殊符号",
            trigger: "blur",
            pattern: /^[\a-\z\A-\Z0-9\u4e00-\u9fe5]+$/
          }
        ],
        testDate: [
          {
            required: true,
            validator: checkTestDate,
            trigger: ["change", "blur"]
          }
        ],
        theoryTime: [
          {
            required: true,
            validator: checkTheoryTime,
            trigger: ["change", "blur"]
          }
        ],
        practicalTime: [
          {
            required: true,
            validator: checkPracticalTime,
            trigger: ["change", "blur"]
          }
        ],

        endTime: [
          { required: true, message: "请输入", trigger: ["blur", "change"] }
        ],
        loginEndTime: [
          { required: true, message: "请输入登录超时时间", trigger: ["blur"] }
        ],
        advanceSubmissionTime: [
          { required: true, message: "请输入提前交卷时间", trigger: ["blur"] }
        ],
        questionPracticalPaperId: [
          {
            required: true,
            message: "请选择实操试卷",
            trigger: ["blur", "change"]
          }
        ],
        questionPaperId: [
          {
            required: true,
            message: "请选择理论试卷",
            trigger: ["blur", "change"]
          }
        ]
      },
      form: {
        endTime: "", //结束考试时间
        name: "", //名称
        testDate: null, //考试日期
        questionPaperId: "", //试卷ID
        startTime: "", //开始考试时间
        practicalStartTime: "", //开始考试时间
        advanceSubmissionTime: 0,
        loginEndTime: 0
      },
      formVisible: false,
      type: "",
      handsOnOption: [],
      PaperName: [],
      theoryDateValue: [],
      handsOnDateValue: [],
      titles: {
        view: "查看",
        edit: "编辑",
        add: "新增"
      }
    };
  },
  computed: {
    title() {
      return this.titles[this.type] || "";
    }
  },
  methods: {
    formatDate,
    validateField(field) {
      this.$refs.formRef.validateField(field);
    },
    isTimeRangeOverlap(range1, range2) {
      if (!range1 || !range2 || range1.length !== 2 || range2.length !== 2) {
        return false; // 如果任何一个范围为空或格式不对，直接返回 false
      }

      // 转换为 Date 对象进行比较
      const start1 = new Date(this.form.testDate + " " + range1[0]);
      const end1 = new Date(this.form.testDate + " " + range1[1]);
      const start2 = new Date(this.form.testDate + " " + range2[0]);
      const end2 = new Date(this.form.testDate + " " + range2[1]);

      // 判断是否有效时间
      if (isNaN(start1) || isNaN(end1) || isNaN(start2) || isNaN(end2)) {
        return false; // 如果有无效时间，直接返回 false
      }

      // 判断两个时间范围是否有交集
      return start1 <= end2 && end1 >= start2;
    },
    testDateChange(val) {
      this.form.testDate = val;
      this.$forceUpdate();
    },
    async open(type, data = {}) {
      this.type = type;
      if (data) {
        this.form = { ...data };
        this.form.testDate = data.startTime
          ? this.formatDate(data.startTime)
          : "";
      }
      await this.allPaperInfo();

      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
    },
    // 获取可用试卷
    async allPaperInfo() {
      let res = await allQuestionPaperInfo();
      this.PaperName = res.data.data;
      let handsRes = await practicalPaperList();
      this.handsOnOption = handsRes.data.data;
    },
    closeDialog() {
      this.form = {
        endTime: "", //结束考试时间
        name: "", //名称
        questionPaperId: "", //试卷ID
        startTime: "", //开始考试时间
        practicalStartTime: "" //开始考试时间
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
        this.$refs.formRef.clearValidate();
      }
      this.formVisible = false;
    },
    async UpdateExamination(param) {
      let res = await editInfo(param);
      let result = res.data;
      if (result.data.code === 500) {
        this.$message.error(result.data.msg);
      } else {
        this.formVisible = false;
        this.$emit("success");
      }
    },
    async AddExamination(param) {
      let res = await createInfo(param);
      let result = res.data;
      if (result.data.code === 500) {
        this.$message.error(result.data.msg);
      } else {
        this.formVisible = false;
        this.$emit("success");
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.form));
          formData.startTime = this.form.testDate + " " + this.form.startTime;
          formData.endTime = this.form.testDate + " " + this.form.endTime;
          formData.practicalExamStartTime =
            this.form.testDate + " " + this.form.practicalExamStartTime;
          formData.practicalExamEndTime =
            this.form.testDate + " " + this.form.practicalExamEndTime;
          if (this.type == "add") {
            this.AddExamination(formData);
          } else {
            this.UpdateExamination(formData);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/TestManage/TestDialog.vue